import '../scss/testimonials.scss'

(function($) {
    
    $('#show-more-testimonials').click(function() {
        $('.hide:lt(3)').slideDown();
        $('.hide:lt(3)').removeClass('hide');
        if($('.hide').length < 1) {
            $("#show-more-testimonials").hide();
        }
    });

})(jQuery);